import React, { useState, useEffect } from 'react'
import { useStoreActions, useStoreState } from 'easy-peasy'
import { Col } from 'reactstrap'
import styled from 'styled-components'
import media from '../../utils/media'
import BtnClose from './BtnClose'
import BtnAction from '../form/BtnAction'
import Text from '../../utils/Text'
import { fadeIn, fadeOut, down, up } from './StyledAnimations'

const Background = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.52);
  height: 100vh;
  overflow-y: hidden;
  animation: ${props => props.appear} 0.5s;
`

const Container = styled.div`
  text-align: center;
  position: fixed;
  height: 100%;
  width: 100%;
  max-width: 400px;
  max-height: 380px;
  z-index: 9999;
  display: block;
  background-color: #ffffff;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  ${media.mobileL`
    max-width: 300px;
  `}
  /* animation: ${props => props.appear} 0.5s; */
`

const Header = styled.div`
  height: 45px;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 5px 37px;
  .no-leave-btn {
    button {
      width: 107px;
      padding: 15px 39px;
    }
  }
  .leave-btn {
    button {
      width: 100%;
      padding: 0 0;
      span {
        font-family: Muli;
        font-size: 13px;
        font-weight: 800;
        border-bottom: 1px solid #414141;
        padding-bottom: 3px;
      }
    }
  }
`

const Title = styled.div`
  margin-bottom: 5px;
  p {
    font-size: 25px;
    font-weight: 600;
    line-height: 1.18;
    letter-spacing: 0.31px;
  }
`

const Subtitle = styled.div`
  margin-bottom: 29px;
  p {
    font-family: Muli;
    font-size: 14px;
    line-height: 1.39;
  }
`

export default function ModalLeave({ config }) {
  const { title, subtitle, btnNoLeave, btnLeave } = config
  const [show, setShow] = useState(false)

  const openModalLeave = useStoreState(
    state => state.form.openModalLeave,
  )

  const [
    setStep,
    setOpenModal,
    setOpenModalLeave,
  ] = useStoreActions(actions => [
    actions.steps.setStep,
    actions.form.setOpenModal,
    actions.form.setOpenModalLeave,
  ])

  useEffect(() => {
    if (openModalLeave) {
      setShow(true)
    } else {
      setShow(false)
    }
  }, [openModalLeave])

  const handleCloseAll = () => {
    setShow(false)
    setTimeout(() => {
      setOpenModal(false)
      setOpenModalLeave(false)
      setStep(0)
    }, 400)
  }

  const handleClose = () => {
    setShow(false)
    setTimeout(() => {
      setOpenModalLeave(false)
    }, 400)
  }

  return (
    <>
      {openModalLeave && (
        <Background appear={show ? fadeIn : fadeOut}>
          <Container appear={show ? down : up}>
            <Header>
              <Col className="align-items-center h-100 position-relative">
                <BtnClose
                  action={() => handleClose()}
                  width="14"
                  height="14"
                />
              </Col>
            </Header>
            <Wrapper>
              <Title>
                <Text id={title} markdown />
              </Title>
              <Subtitle>
                <Text id={subtitle} markdown />
              </Subtitle>
              <BtnAction
                btn={btnNoLeave}
                action={() => handleClose()}
                className="no-leave-btn"
              />
              <BtnAction
                btn={btnLeave}
                action={() => handleCloseAll()}
                className="leave-btn"
              />
            </Wrapper>
          </Container>
        </Background>
      )}
    </>
  )
}
